// ------------------------------------------------------ Page Animations //
const scenes = {
  elms: [
    '.section-2',
    '.better-together',
    '.recent-news',
  ],
};

buildScenes(scenes);

// ------------------------------------------------------ Play Better Together Video //
new ScrollMagic.Scene({
  offset: viewportHeight / 3,
  reverse: false,
  triggerElement: '.better-together',
  triggerHook: 'onEnter',
})
  .on('enter', () => {
    $('.better-together video').get(0).play();
  })
  .addTo(scrollMagicController);

// ------------------------------------------------------ Leave Active block on last hover //
$('body').on('mouseover', '.block', function() {
  $('.block').removeClass('active-block');
  $(this).addClass('active-block');
});

// ------------------------------------------------------ Article Link //
$('body').on('click', '.recent-news .block', function() {
  const id = $(this).data('id');
  const type = $(this).data('type');
  const slug = $(this).data('slug');
  const fileName = $(this).data('file');
  const title = $(this).data('title');

  if (slug === 'no-link') {
    return false;
  }
  else if (type === 'white-papers') {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    $('#modal-cover').delay(750).fadeIn('fast');
    $('#whitepaper-modal').delay(750).fadeIn('fast');
    $('#whitepaper-title').val(title);
    $('#whitepaper-modal h1').text(title);
    $('#whitepaper-filename').val(fileName);
    $('#whitepaper-id').val(id);
  }
  else if (fileName) {
    const href = `//s3.amazonaws.com/spartacus-prod/news_causaliq/${id}/${fileName}`;
    forceDownload(href, fileName);
  }
  else {
    window.location.href = `/our-work/${type}/${slug}`;
  }
  return false;
});

// ------------------------------------------------------ White Paper Form & Modal //

$('body').on('click', '#modal-cover', () => {
  $('#modal-cover').fadeOut('fast');
  $('#whitepaper-modal').fadeOut('fast');
});

$('#whitepaper-form-submit').click(() => {
  $('#whitepaper-form').submit();
});

_validator = $('#whitepaper-form').validate({
  ignore: [],
  onfocusout(element) {
    $(element).valid();
  },
  rules: {
    first_name: {
      required: true,
    },
    last_name: {
      required: true,
    },
    email: {
      required: true,
      email: true,
    },
    company: {
      required: true,
    },
  },
  messages: {
    first_name: {
      required: 'First Name is required.',
    },
    last_name: {
      required: 'Last Name is required.',
    },
    email: {
      required: 'Email is required.',
    },
    company: {
      required: 'Company is required.',
    },
  },
  highlight(element) {
    $(element).closest('div').addClass('error').removeClass('valid');
  },
  unhighlight(element) {
    $(element).closest('div').removeClass('error').addClass('valid');
  },
  errorPlacement(error, element) {
    const message = error.html();

    if (message.length > 0) {
      $(element[0]).closest('div.error').append(error);
    }
  },
  // ---------------------------------------------------- FORM SUMBIT HANDLER //
  submitHandler() {
    $('#contact-form-submit').attr('disabled', 'disabled');

    $.ajax({
      url: '/ajax/ourwork/whitepaper',
      type: 'POST',
      dataType: 'json',
      data: $('form').serialize(),
    })
      .done(response => {
        if (!response.err) {
          const fileName = $('#whitepaper-filename').val();
          const id = $('#whitepaper-id').val();
          const href = `//s3.amazonaws.com/spartacus-prod/news_causaliq/${id}/${fileName}`;
          forceDownload(href, fileName);
          $('#whitepaper-form').fadeOut('fast', () => {
            $('#whitepaper-form-thankyou').fadeIn('fast');
          });
        }
        else {
          console.log(response.response);
          $('#contact-form-submit').removeAttr('disabled');
        }
      })
      .fail(() => {
        $('#contact-form-submit').removeAttr('disabled');
      });
  },
});

// ------------------------------------------------------ Force Downloads //
function forceDownload(href, fileName) {
  const link = document.createElement('a');

  link.setAttribute('href', href);
  link.setAttribute('download', fileName);
  link.setAttribute('target', '_blank');
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
